function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3431 12.2927L23.7071 15.6567C24.0976 16.0472 24.0976 16.6804 23.7071 17.0709L20.3431 20.4348C19.9526 20.8254 19.3195 20.8254 18.9289 20.4348C18.5384 20.0443 18.5384 19.4112 18.9289 19.0206L20.5858 17.3638H9C8.44772 17.3638 8 16.9161 8 16.3638C8 15.8115 8.44772 15.3638 9 15.3638H20.5858L18.9289 13.7069C18.5384 13.3164 18.5384 12.6832 18.9289 12.2927C19.3195 11.9022 19.9526 11.9022 20.3431 12.2927Z",
  fill: "#D6DAE0"
});

var SvgLineArrow = function SvgLineArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLineArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lineArrow.0c532182.svg";
export { ForwardRef as ReactComponent };